import {useMutation} from "@tanstack/react-query";
import {removeCustomerOfferNoteMutationOptions} from "./remove-customer-offer-note.mutation-options";

export function useRemoveCustomerOfferNote(id: string) {
  return useMutation(removeCustomerOfferNoteMutationOptions(id));
}
